import React, { useState } from "react";
import { closeModal } from "../../store/slices/editModalSlice";
import { useDispatch } from "react-redux";
import DeleteModalQuestions from "../Modals/DeleteModal/DeleteModalQuestions";
import { openModalDelete } from "../../store/slices/deleteModalQuestionsSlice";
import { FaPencilAlt } from "react-icons/fa";
import EditModalQuestion from "../Modals/EditModal/EditModalQuestion";

const TableItemsQuestionsResponsive = ({ dataQuestions, baseUrl }) => {
  const dispatch = useDispatch();
  const [open, setOpen] = useState(false);
  const [item, setItem] = useState();
  const handleCloseModal = () => {
    dispatch(closeModal());
  };

  const handleOpenModal = (id) => {
    dispatch(openModal(id));
  };

  const handleDeleteItem = (id) => {
    dispatch(openModalDelete(id));
  };

  const openModal = (item) => {
    setItem(item);
  };
  const onClose = () => {
    setOpen(!open);
  };
  return (
    <>
      {open && <EditModalQuestion item={item} onClose={onClose} />}
      <div className="block sm:hidden space-y-4">
        {dataQuestions?.data?.map((item) => (
          <div
            key={item.id}
            className="bg-white shadow rounded-lg p-4 text-sm space-y-2"
          >
            <p>
              <strong>Pyetja:</strong> {item.question_text}
            </p>
            <p>
              <strong>Testi:</strong> {item.testName}
            </p>
            <p>
              <strong>Kategoria:</strong> {item.testCategoryName}
            </p>
            <p>
              <strong>Pikët:</strong> {item.score}
            </p>
            <p>
              <strong>Foto:</strong>
              <br />
              <a
                href={`${baseUrl}/${item.photo_path}`}
                target="_blank"
                rel="noopener noreferrer"
              >
                <img
                  src={`${baseUrl}/${item.photo_path}`}
                  alt="Question"
                  className="w-12 h-12 object-cover mt-1"
                />
              </a>
            </p>
            <div className="flex gap-3 items-center pt-2">
              <button
                onClick={() => {
                  setOpen(true);
                  openModal(item);
                }}
              >
                <FaPencilAlt
                  style={{ width: 20, height: 20, color: "#21C621" }}
                />
              </button>
              <button onClick={() => handleDeleteItem(item.id)}>
                <DeleteModalQuestions
                  id={item.id}
                  onCancel={handleCloseModal}
                />
              </button>
            </div>
          </div>
        ))}
      </div>
    </>
  );
};

export default TableItemsQuestionsResponsive;
